import React from "react";

export const About = () => {
  return (
    <section id="about" className="section-divider radio-waves relative" style={{ "--rw-x": "100%", "--rw-y": "50%" }} data-testid="about-section">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-4 lg:order-2">
            <figure className="relative ml-auto" data-testid="founder-portrait-wrap" style={{ maxWidth: 360 }}>
              {/* atomic shape behind */}
              <div className="absolute -top-5 -left-5 w-28 h-28 rounded-full opacity-90 -z-0" style={{ background: "var(--bpm-orange)" }} aria-hidden />
              <div
                className="absolute -bottom-5 -right-5 w-32 h-32 rounded-full z-10"
                style={{ background: "var(--bpm-teal)", color: "var(--bpm-night)", fontFamily: "Atkinson Hyperlegible, sans-serif" }}
                data-testid="founder-badge"
              >
                <div
                  className="absolute left-0 right-0 text-center px-3 font-bold text-[15px] leading-tight"
                  style={{ top: "50%", transform: "translateY(-50%)" }}
                >
                  Erin Amar
                </div>
                <div
                  className="absolute left-0 right-0 text-center px-3 text-[12px] leading-tight"
                  style={{ top: "calc(50% + 14px)" }}
                >
                  Founder
                </div>
              </div>
              <div
                className="relative overflow-hidden rounded-full"
                style={{ border: "1px solid var(--bpm-line-strong)", width: "100%", aspectRatio: "1 / 1" }}
              >
                <img
                  src="/erin-amar.jpg"
                  alt="Erin Amar, Founder of Boston Pro Marketing"
                  className="block w-full h-full"
                  style={{ objectFit: "cover" }}
                  data-testid="founder-portrait"
                />
              </div>
            </figure>
          </div>

          <div className="lg:col-span-8 lg:order-1 lg:pr-6">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl">
              About BPM
            </h2>
            <div className="mt-8 space-y-5 text-[16px] md:text-[17px] leading-[1.75] text-[color:var(--bpm-cream-soft)] max-w-xl">
              <p>
                At BPM, email marketing isn&apos;t just one service we offer
                — it&apos;s our passion. Among the most powerful ways to
                connect with your customers, it provides unmatched return on
                investment (ROI): enhancing your customer relationship, reinforcing
                your brand, and growing your influence. Personal, measurable,
                flexible, and reliable, it&apos;s our absolute favorite
                owned-media platform.
              </p>
              <p>
                With more than a decade in B2C email marketing, our
                principal — Erin Amar — brings a defined history of success
                in honing lists and emails for best performance. From
                assisting small brick-and-mortar vendors to helming the
                275,000+ list at the Boston Public Library, her top open
                rates were consistently over 60% — a far cry from industry
                standards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
